/** Speed-dependent normal restitution, adapted from Penner (2002), eq. 5.
 * https://www.raypenner.com/golf-run.pdf — measured on relatively soft turf, not a
 * universal surface law. Surface presets scale the low-speed restitution.
 * This is only the normal response, not Penner's inclined-contact model. */
export function turfRestitution(normalSpeed: number, lowSpeedRestitution: number): number {
  const speed = Math.abs(normalSpeed);
  const reference = speed > 20 ? 0.12 : 0.510 - 0.0375 * speed + 0.000903 * speed * speed;
  return Math.max(0, Math.min(1, lowSpeedRestitution * reference / 0.510));
}
